import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowLeft from '../../Assets/Arrow left.svg';
import AddProductImage from "./Components/AddProductImage";
import { useContext, useEffect, useState } from "react";
import VariantDetails from "./Components/VariantDetails";
import { EditVariantFormContext } from "../../Context/EditVariantFormContext";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import LoadingTransparent from "../../Components/Loading/LoadingTransparent";
import { getMediaUrl } from "../../lib/utils/utils";
import imageCompression from 'browser-image-compression';
import { showToast } from "../../Components/Toaster/Toaster";
import { cachedDataPublish, updateProductVariant } from "../../lib/utils/apiCalls";
import Input from "../../Components/Input/Input";

function EditVariant() {
    // const params = useParams();
    // const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const selectedVariant = useSelector((state) => state.inventoryManagement.selectedVariant);
    const { products } = useSelector((state) => state.inventoryManagement.products);

    const {
        formErrors,
        setFormErrors,
        formInputs,
        setFormInputs,
        productImages,
        setProductImages,
        defaultFormErrors,
        loading,
        setLoading,
    } = useContext(EditVariantFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormInputs({ ...formInputs, [name]: value });
    }

    const [productCategory, setProductCategory] = useState('');

    useEffect(() => {
        if(Object.keys(selectedVariant).length > 0) {
            const {
                VarientMrp,
                VarientPrice,
                VarientSize,
                VarientColor,
                VarientName,
                VarientQuantity,
                sku,
                VarientImgUrl,
            } = selectedVariant;

            const foundProduct = products.find(item =>
                item?.varients.some(variant => variant.id === selectedVariant.id)
            );

            setProductCategory(foundProduct?.product?.productCategory || '');

            const foundVariant = foundProduct?.varients.find(
                variant => variant.id === selectedVariant.id
            );

            const resolvedSKU =
            (foundVariant?.VarientSize === VarientSize &&
            foundVariant?.VarientColor === VarientColor &&
            foundVariant?.sku)
                ? foundVariant?.sku
                : sku;

            setFormInputs({
                VarientMrp,
                VarientPrice: VarientPrice === "" ? 0 : Number(VarientPrice) || 0,
                VarientSize,
                VarientColor,
                VarientName,
                VarientQuantity,
                Sku: sku || resolvedSKU,
            });

            let productImageList;
            if(VarientImgUrl && VarientImgUrl.length > 0) {
                productImageList = VarientImgUrl.map(img => ({
                    id: uuidv4(),
                    url: img,
                    file: null,
                }));
                setProductImages(productImageList);
            }
            else {
                setProductImages([]);
            }
        }
    }, [selectedVariant]);

    function handleCancelClick() {
        navigate(`${location.pathname.split('/').slice(0, -1).join('/')}`);
    }

    async function handleSaveClick() {
        const validationErrors = {};

        if(!formInputs.VarientMrp) {
            validationErrors.VarientMrp = 'Required field';
        }

        if(!formInputs.VarientPrice) {
            validationErrors.VarientPrice = 'Required field';
        }

        if(productCategory !== 'Beauty & Personal Care') {
            if(!formInputs.VarientColor) {
                validationErrors.VarientColor = 'Required field';
            }
        }

        if(!formInputs.VarientSize) {
            validationErrors.VarientSize = 'Required field';
        }

        if (formInputs.VarientQuantity === '' || formInputs.VarientQuantity == null) {
            validationErrors.VarientQuantity = 'Required field';
        }

        if(productImages.length === 0) {
            validationErrors.VarientImgUrl = 'Variant image is required';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);
            setLoading(true);

            const VarientImgUrl = [];

            for(const image of productImages) {
                let url;

                if(image.file) {
                    url = await getMediaUrl(image.file);

                    if(image.file.size > 1048576) {
                        try {
                            let compressedBlob = await imageCompression(image.file, {
                                maxSizeMB: 1,
                                maxWidthOrHeight: 1920,
                                useWebWorker: true
                            });

                            let compressedFile = new File([compressedBlob], image.file.name, { type: image.file.type, lastModified: Date.now() });

                            if (compressedFile) {
                                url = await getMediaUrl(compressedFile);
                            }
                            else {
                                url = await getMediaUrl(image.file);
                            }
                        }
                        catch(err) {
                            url = await getMediaUrl(image.file);
                        }
                    }
                    else {
                        url = await getMediaUrl(image.file);
                    }
                }
                else {
                    url = image.url;
                }

                VarientImgUrl.push(url);
            }

            const { Sku, VarientQuantity, ...rest } = formInputs;

            const callBody = {
                ...rest,
                sku: Sku,
                VarientImgUrl,
            };

            if(Number(selectedVariant.VarientQuantity ) > Number(VarientQuantity)) {
                callBody.VarientQuantity = VarientQuantity;
                callBody.typeOperation = 'sub';
                callBody.productId = selectedVariant.ProductId;
            }
            else if(Number(selectedVariant.VarientQuantity ) < Number(VarientQuantity)) {
                callBody.VarientQuantity = VarientQuantity;
                callBody.typeOperation = 'add';
                callBody.productId = selectedVariant.ProductId;
            }

            try {
                const response = await updateProductVariant(callBody, selectedVariant.id);
                if(response.status === 200) {
                    await cachedDataPublish([`/v1/product/${selectedVariant.ProductId}`]);
                    showToast('Product variant updated.', 'success');
                    setLoading(false);
                    navigate('..');
                }
                else {
                    showToast('Failed to update to product variant.', 'error');
                }
            }
            catch(err) {
                showToast('Failed to update to product variant.', 'error');
            }
        }
        else {
            setFormErrors(validationErrors);
        }
    }

    return (
        <div className="w-full overflow-y-scroll pb-16 no-scrollbar">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>
            
                    <h1 className="p-[6px] text-[#121212] font-urbanist-regular font-bold leading-8 text-[24px]">Edit Variant</h1>
                </div>
            </div>

            <div className="mt-6 mx-5 flex flex-col gap-4">
                <div className="w-[65%] flex flex-col gap-4">
                    <div className="p-5 border border-[#EAEAEA] rounded-xl">
                        <Input 
                            labelText='Variant Name' 
                            errorText={formErrors.VarientName} 
                            inputOptions={{
                                type: 'text',
                                id: 'VarientName',
                                name: 'VarientName',
                                placeholder: 'Enter variant name',
                                value: formInputs.VarientName,
                                onChange: handleChange
                            }} 
                            required 
                        />
                    </div>

                    <AddProductImage 
                        errorText={formErrors.VarientImgUrl} 
                    />

                    <VariantDetails />
                </div>

                <div className="w-[65%] flex justify-end gap-3">
                    <button onClick={handleCancelClick} className='outline-none px-5 py-[10px] bg-[#FFFFFF] rounded font-semibold text-base text-[#808080]'>Cancel</button>

                    <button onClick={handleSaveClick} className='outline-none px-5 py-[10px] bg-primaryColor hover:bg-primaryAccent rounded font-semibold text-base text-buttonText'>Save</button>
                </div>
            </div>

            {
                loading && 
                <LoadingTransparent 
                    message="Updating variant..."
                />
            }
        </div>
    );
}

export default EditVariant;
